import { layoutViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    activeLayoutCategoryIndex: 0,
    activeLayoutTabIndex: 0
}

export default function layoutViewerSlice(state = initialState, action) {
    switch (action.type) {
        case layoutViewerSliceDispatch.setActiveLayoutCategoryIndex: {
            return {
                ...state,
                activeLayoutCategoryIndex: action.payload
            }
        }
        case layoutViewerSliceDispatch.setActiveLayoutTabIndex: {
            return {
                ...state,
                activeLayoutTabIndex: action.payload
            }
        }
        default:
            return state
    }
}
